import { Observable } from "rxjs";
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from "@angular/common/http";
import { catchError } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { ExceptionFactory } from "../exceptions/exception.factory";

export interface HttpOptions {
    headers?: HttpHeaders | {
        [header: string]: string | string[];
    };
    params?: HttpParams | {
        [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
    };
}

export abstract class AclApi {
    private readonly apiUrl = environment.apiUrl;
    private readonly path: string;

    protected exceptionFactory: ExceptionFactory;

    protected constructor(path: string, protected httpClient: HttpClient) {
        this.path = path;
    }

    protected url(route = ""): string {
        if (route === "" && (!this.path || this.path === "")) {
            return this.apiUrl;
        } else if (route === "") {
            return `${this.apiUrl}/${this.path}`;
        }
        return `${this.apiUrl}/${this.path}/${route}`;
    }

    protected delete<T>(route = "", options?: HttpOptions): Observable<T> {
        return this.httpClient.delete<T>(this.url(route), options).pipe(
            catchError(e => this.transformError(e))
        );
    }

    protected get<T>(route = "", options?: HttpOptions): Observable<T> {
        return this.httpClient.get<T>(this.url(route), options).pipe(
            catchError(e => this.transformError(e))
        );
    }

    protected patch<T>(route = "", body?: any, options?: HttpOptions): Observable<T> {
        return this.httpClient.patch<T>(this.url(route), body, options).pipe(
            catchError(e => this.transformError(e))
        );
    }

    protected post<T>(route = "", body?: any, options?: HttpOptions): Observable<T> {
        return this.httpClient.post<T>(this.url(route), body, options).pipe(
            catchError(e => this.transformError(e))
        );
    }

    protected put<T>(route = "", body?: any, options?: HttpOptions): Observable<T> {
        return this.httpClient.put<T>(this.url(route), body, options).pipe(
            catchError(e => this.transformError(e))
        );
    }

    private transformError(error: HttpErrorResponse): Observable<any> {
        if (!this.exceptionFactory) {
            throw error;
        }
        throw this.exceptionFactory.transform(error);
    }
}
